/*eslint-disable*/
import classNames from "classnames";
import compact from "lodash/compact";
import isFunction from "lodash/isFunction";
import size from "lodash/size";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router";
import ChatActions from "../../../actions/ChatActions";
import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";
import { createSanitizedMarkup } from "../../../utils/Utils";
import { useRerouteContext } from "../RerouteContext";

import { history } from "../../../utils/chat/chatNavigation";

const QuestionReroutedSystemMessage = ({
    messageActions: rawMessageActions,
    messageText,
    showAskNewQuestionMessage,
    question,
    onRerouteComplete,
}) => {
    const messageActions = compact(rawMessageActions);
    const messageActionCount = size(messageActions);
    const reroutedMessageClasses = classNames({
        "system-message": true,
        "message-question-rerouted": true,
        "has-sibling": messageActionCount > 0,
    });

    const { rerouteType } = useRerouteContext();

    const showFooter = [
        "Alexkumar",
        "Autodesk",
        "Madonna 1234",
        "rainbow",
        "Redwood",
        "Autodesk Sandbox",
        "AllenMuse",
    ].includes(question.company);

    const actions = messageActions.map((action, key) => {
        const isLast = key + 1 === messageActionCount;
        const actionClasses = classNames({
            "system-message": true,
            "has-sibling": !isLast,
        });

        return (
            <div className={actionClasses} key={key}>
                {isFunction(action.intent) ? (
                    <a className="system-message-action" onClick={action.intent}>
                        <strong>{action.label}</strong>
                    </a>
                ) : (
                    <a className="system-message-action" href={action.intent} target="_blank">
                        <strong>{action.label}</strong>
                    </a>
                )}
            </div>
        );
    });

    const handleKeyPress = event => {
        if (event.charCode === 32 || event.charCode === 13) {
            history.push("/ask");
        }
    };

    return (
        <li>
            {(() => {
                if (rerouteType === "optout" && showFooter) {
                    return (
                        <div className={reroutedMessageClasses}>
                            <div className="icon icon-arrow-right">
                                <SvgIcon src={iconSprite} id="icon-arrow-right" />
                            </div>
                            <p className="body">
                                <h3>Opted out for all Autodesk questions.</h3>
                                <strong>
                                    Your case has been routed to an Autodesk Agent. You will no longer receive answer
                                    from Autodesk Experts.
                                </strong>
                            </p>
                        </div>
                    );
                } else if (rerouteType === "reroute" && showFooter) {
                    return (
                        <div className={reroutedMessageClasses}>
                            <div className="icon icon-arrow-right">
                                <SvgIcon src={iconSprite} id="icon-arrow-right" />
                            </div>

                            <p className="body">
                                <h3>Opted out for this question.</h3>
                                <strong>You will no longer receive answers from the Autodesk Expert crowd.</strong>
                            </p>
                        </div>
                    );
                } else {
                    return (
                        <div className={reroutedMessageClasses}>
                            <div className="icon icon-arrow-right">
                                <SvgIcon src={iconSprite} id="icon-arrow-right" />
                            </div>
                            <p
                                className="body"
                                dangerouslySetInnerHTML={createSanitizedMarkup(
                                    i18n.t("rtm.text.your_question_has_been_routed")
                                )}
                            />
                        </div>
                    );
                }
            })()}

            {actions}

            {messageActionCount === 0 && showAskNewQuestionMessage && !showFooter && (
                <div className="system-message message-ask-new-question">
                    <div className="icon icon-speech-bubble">
                        <SvgIcon src={iconSprite} id="icon-speech-bubble" />
                    </div>
                    <p className="body">
                        {i18n.t("rtm.text.additional_help_part_1") + " "}
                        <Link to="ask" onKeyPress={handleKeyPress}>
                            <strong>{i18n.t("rtm.text.additional_help_part_2")}</strong>
                        </Link>
                        .
                    </p>
                </div>
            )}
        </li>
    );
};

QuestionReroutedSystemMessage.propTypes = {
    messageActions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            intent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
        })
    ),
    messageText: PropTypes.string,
    showAskNewQuestionMessage: PropTypes.bool,
    question: PropTypes.shape({
        company: PropTypes.string,
    }).isRequired,
    onRerouteComplete: PropTypes.func,
};

QuestionReroutedSystemMessage.defaultProps = {
    messageActions: [],
    messageText: i18n.t("rtm.text.your_question_has_been_routed"),
};

export default QuestionReroutedSystemMessage;
